/*
 I don't yet know how we'll interact with the common SolarWinds
 feature flag service, but I imagine we'll want to define and
 export any flags relevant to the nav links here so all
 consumers know which ones to ask the feature flag service about.
*/
export var FeatureFlag;

(function (FeatureFlag) {
  FeatureFlag["API_TOKENS"] = "apiTokens";
  FeatureFlag["PINGDOM_CONVERGED"] = "pingdomConverged";
  FeatureFlag["LIVE_CHAT"] = "livechat";
})(FeatureFlag || (FeatureFlag = {}));